// 全局常量文件

export const common = {
  sdkVersion: '1.0.0',
  signType: 'md5',
}

export const dpcq = {
  name: 'dpcq',
  // 活动标识，后台取值（找后端提供）
  activityLabel: {
    default: 'df7Vcu5cSq5UWgtHdo4d',
  },
  // 服务器时间
  serverTime: '',
  // 服务器时间与客户端时间 差值
  differenceTime: '',
  // 初始化key，header头保持使用这个
  initKey: 'Mn343Wc57RrFNlUz2zrYSPGO6lDsvf1s',
  aesKey: '3nJirQ9hP2zJ4WfH7ElOUUkoS5JeH7iS',
  // 初始化接口返回key，真实接口使用
  appKey: '',
  // 公钥
  publickey: '',
  // 私钥
  privateKey: '',
}

export const qyn = {
  name: 'qyn',
  // 活动标识，后台取值（找后端提供）
  activityLabel: {
    default: 'ihtzSV9ua3QxTgL4PO3S',
  },
  // 服务器时间
  serverTime: '',
  // 服务器时间与客户端时间 差值
  differenceTime: '',
  // 初始化key，header头保持使用这个
  initKey: 'Mn343Wc57RrFNlUz2zrYSPGO6lDsvf1s',
  aesKey: '3nJirQ9hP2zJ4WfH7ElOUUkoS5JeH7iS',
  // 初始化接口返回key，真实接口使用
  appKey: '',
  // 公钥
  publickey: '',
  // 私钥
  privateKey: '',
}

export const cdjz = {
  name: 'jz',
  // 活动标识，后台取值（找后端提供）
  activityLabel: {
    default: 'XTX0l6xfHv7z2o2v',
  },
  // 服务器时间
  serverTime: '',
  // 服务器时间与客户端时间 差值
  differenceTime: '',
  // 初始化key，header头保持使用这个
  initKey: 'Mn343Wc57RrFNlUz2zrYSPGO6lDsvf1s',
  aesKey: '3nJirQ9hP2zJ4WfH7ElOUUkoS5JeH7iS',
  // 初始化接口返回key，真实接口使用
  appKey: '',
  // 公钥
  publickey: '',
  // 私钥
  privateKey: '',
}

export const dmbj = {
  name: 'dmbj',
  // 活动标识，后台取值（找后端提供）
  activityLabel: {
    default: 'ejSWQedCMKemQRX0',
    lottery: 'iP1FmCbRf4qJq2nh',
  },
  // 服务器时间
  serverTime: '',
  // 服务器时间与客户端时间 差值
  differenceTime: '',
  // 初始化key，header头保持使用这个
  initKey: 'Mn343Wc57RrFNlUz2zrYSPGO6lDsvf1s',
  aesKey: '3nJirQ9hP2zJ4WfH7ElOUUkoS5JeH7iS',
  // 初始化接口返回key，真实接口使用
  appKey: '',
  // 公钥
  publickey: '',
  // 私钥
  privateKey: '',
}

export const ro = {
  name: 'ro',
  // 活动标识，后台取值（找后端提供）
  activityLabel: {
    default: 'q03RU5PefYyN8XbtIWT6',
  },
  // 服务器时间
  serverTime: '',
  // 服务器时间与客户端时间 差值
  differenceTime: '',
  // 初始化key，header头保持使用这个
  initKey: 'Mn343Wc57RrFNlUz2zrYSPGO6lDsvf1s',
  aesKey: '3nJirQ9hP2zJ4WfH7ElOUUkoS5JeH7iS',
  // 初始化接口返回key，真实接口使用
  appKey: '',
  // 公钥
  publickey: '',
  // 私钥
  privateKey: '',
}

export const projectType = () => {
  if (process.env.VITE_APP_ID === 'dpcq') {
    return dpcq
  }

  if (process.env.VITE_APP_ID === 'qyn') {
    return qyn
  }

  if (process.env.VITE_APP_ID === 'cdjz') {
    return cdjz
  }

  if (process.env.VITE_APP_ID === 'dmbj') {
    return dmbj
  }

  if (process.env.VITE_APP_ID === 'ro') {
    return ro
  }
}
